"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeModule = void 0;
const tslib_1 = require("tslib");
const AdaptableModuleBase_1 = require("./AdaptableModuleBase");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
const ThemeStatusbar_1 = require("../View/Theme/ThemeStatusbar");
class ThemeModule extends AdaptableModuleBase_1.AdaptableModuleBase {
    constructor(api) {
        super(ModuleConstants.ThemeModuleId, ModuleConstants.ThemeFriendlyName, 'theme', 'ThemePopup', 'Theme AdapTable with a colour configuration set of your choosing', api);
    }
    getModuleAdaptableObjects() {
        return this.api.themeApi.getThemes();
    }
    hasNamedQueryReferences() {
        return false;
    }
    getViewProperties() {
        return {
            getStatusBarPanelProps: () => {
                return {
                    content: ThemeStatusbar_1.ThemeStatusbar,
                };
            },
        };
    }
}
exports.ThemeModule = ThemeModule;
